// Version utility for the application
// Update this constant when you want to change the version
export const APP_VERSION = '1.0.9'; 